export interface SortItem {
  title: string;
  /**
   * determines which field should be sorted for instance : Title, CreatedAt, UpdatedAt
   */
  sortField: string;
  sortBy: 'Descending' | 'Ascending' | 'OrderByDescending' | 'OrderBy';
}
